module.exports = __webpack_public_path__ + "static/media/checkmark_green.216a5db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/utils/checkmark_green.png
// module id = 604
// module chunks = 0